import "@/App.css";
import useLenis from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Gallery } from "@/components/site/Gallery";
import { WhyUs } from "@/components/site/WhyUs";
import { Location } from "@/components/site/Location";
import { Contact } from "@/components/site/Contact";
import { CtaCall } from "@/components/site/CtaCall";
import { Footer } from "@/components/site/Footer";

function App() {
    useLenis();

    return (
        <div className="App">
            <div className="grain-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Services />
                <Gallery />
                <WhyUs />
                <CtaCall />
                <Location />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
